import React from 'react';
import UserFunctionalityNavbar from './UserFunctionalityNavbar';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ShareExperiences() {
  return (
    <>
    
    <UserFunctionalityNavbar/>

    <ToastContainer/>
    
    </>
  )
}

export default ShareExperiences
